import React from "react";
import { Box } from '@curves/ui-base';
import { MeasurementBarItem } from "../Common";

const CIDBalanceBarItems = ({ sourceData }) => {
	return (
		<Box className="measurement-group-content">
			<Box className="measurement-group-content__CIDtext">{sourceData?.cidBodyShapeStyleText}</Box>
			<MeasurementBarItem
				name="體重"
				value={sourceData?.weight}
				unit="kg"
				percentageProp={sourceData?.weightBarPercentage}
				className="measurement-group-content__item"
			/>
			<MeasurementBarItem
				name="骨骼肌重"
				value={sourceData?.smm}
				unit="kg"
				percentageProp={sourceData?.smmBarPercentage}
				className="measurement-group-content__item"
			/>
			<MeasurementBarItem
				name="體脂肪重"
				value={sourceData?.bfm}
				unit="kg"
				percentageProp={sourceData?.bfmBarPercentage}
				className="measurement-group-content__item"
			/>
		</Box>
	);
};

export default CIDBalanceBarItems;
